import { render, staticRenderFns } from "./CreateRevModalByType.vue?vue&type=template&id=fc0fc04e"
import script from "./CreateRevModalByType.vue?vue&type=script&lang=js"
export * from "./CreateRevModalByType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports